import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ no, label, light = false }) => (
  <div className="flex items-center gap-4 mb-6" data-testid={`section-tag-${label.toLowerCase().replace(/\s+/g, "-")}`}>
    <span className={`font-tech text-xs tracking-[0.25em] ${light ? "text-copper" : "text-copper"}`}>
      [ {no} ]
    </span>
    <span
      className={`font-tech text-xs uppercase tracking-[0.25em] ${
        light ? "text-gray-400" : "text-gray-500"
      }`}
    >
      {label}
    </span>
    <span className={`h-px flex-1 ${light ? "bg-white/15" : "bg-gray-300"}`} />
  </div>
);

export const KineticLine = ({ text, delay = 0, className = "" }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {text}
    </motion.span>
  </span>
);
